var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.36 97.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #dcba8b;\n      }\n      .cls-2 {\n        fill: #dadada;\n      }\n      .cls-3 {\n        fill: #1e0e00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angry"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 289.57,
    cy: 56.42,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 289.57,
    cy: 43.19,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 64.79,
    cy: 56.42,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 64.79,
    cy: 41.43,
    rx: 64.79,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 282.96,
    cy: 43.19,
    r: 28.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.28,
    cy: 41.43,
    r: 28.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset30);
export default __webpack_public_path__ + "static/media/Asset 30.1c6f69ef.svg";
export { ForwardRef as ReactComponent };